import { isEmpty } from '@intelligence/v3/utils/common';
import { NewzooToDatabrain } from '@intelligence/utils/constant';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { toDateTypeLy } from '@/pages/intelligence/utils/common';
import {
  alineaPsMetricBoxBase,
  alineaSteamMetricBoxBase,
  alineaXboxMetricBoxBase,
} from '@intelligence/pages/TopCharts/_config/metricBoxGroupUtils';
import type { TAlineaTrueDataMetric } from '../../utils/alineaTrueData';

// Segment选择时默认不勾选的数据源列表
// PCConsole 端 Gamalytic 已被 Alinea 替代，快捷选中（收入/销量/PCU/价格/活跃 等）
// 不再纳入 Gamalytic 指标，仅保留 Alinea 等其它数据源即可。
export const SEGMENT_DEFAULT_EXCLUDE_DATA_SOURCES = ['vginsights', 'gamalytic'];

export interface IMetricsOptionItem {
  text: string;
  value: string;
  valueOther?: string;
  // 表头文案占用宽度
  width: number;
  width_cn?: number;
  // 宽表少于 4 列时表头文案不需要折行，指定不折行中英文所需宽度
  noWrapWidth?: number;
  noWrapWidthCN?: number;
  icon?: string;
  dataSource: string;
  bubbleDataSource?: string; // 气泡提示中显示的数据源，不影响实际 dataSource
  metricValue: string;
  metricsType: string;
  dateEnum: ('daily' | 'weekly' | 'monthly' | 'hourly')[];
  renderType?: RenderType;
  tabName?: string;
  segType?: string;
  info?: string;
  iconInfo?: string;
  infoDetail?: string;
  infoSuffix?: string;
  messagekey?: string;
  selectShortType?: any;
  weekly?: string;
  monthly?: string;
  isNoMore?: boolean;
  newMore?: boolean;
  hasByDevice?: boolean;
  /**
   * Countries User Engagement 页柱图是否显示 by platform 拆分按钮
   */
  hasByDeviceBar?: boolean;
  /**
   * Countries User Engagement 页柱图是否显示堆叠折线图图表及按钮
   */
  noStackedLineChart?: boolean;
  /** MetricBox 分行展示键（不影响 dataSource / Sources 筛选） */
  metricBoxGroup?: string;
  /** MetricBox 行首不展示数据源 icon */
  hideMetricBoxIcon?: boolean;
  /** KPI Trends Alinea History 真数映射；普通指标不配置。 */
  trueDataMetric?: TAlineaTrueDataMetric;
}

// ampere
export const ampereMetricOptions: IMetricsOptionItem[] = [
  {
    text: 'dbi_metric_mau',
    value: 'ampere_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['hot', 'ampere', 'mau', 'engagement'],
    dateEnum: ['monthly'],
    info: `dbi_info_ampere_mau`,
    infoDetail: 'dbi_info_ampere_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_previous_mau',
    value: 'ampere_previous_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'mau',
    selectShortType: ['ampere', 'mau'],
    dateEnum: ['monthly'],
    info: 'dbi_info_ampere_previous_mau',
    infoDetail: 'dbi_info_ampere_previous_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_added_mau',
    value: 'ampere_added_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'mau',
    selectShortType: ['ampere', 'mau'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_added_mau',
    infoDetail: 'dbi_metric_ampere_added_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_new_mau',
    value: 'ampere_new_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'mau',
    selectShortType: ['ampere', 'mau'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_new_mau',
    infoDetail: 'dbi_metric_ampere_new_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_retained_mau',
    value: 'ampere_retained_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'mau',
    selectShortType: ['ampere', 'mau'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_retained_mau',
    infoDetail: 'dbi_metric_ampere_retained_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_churned_mau',
    value: 'ampere_churned_mau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'mau',
    selectShortType: ['ampere', 'mau'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_churned_mau',
    infoDetail: 'dbi_metric_ampere_churned_mau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_dau',
    value: 'ampere_dau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    dateEnum: ['daily'],
    selectShortType: ['hot', 'ampere', 'dau', 'engagement'],
    info: 'dbi_metric_ampere_dau',
    infoDetail: 'dbi_metric_ampere_dau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_new_dau',
    value: 'ampere_new_dau',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'dau',
    selectShortType: ['ampere', 'dau'],
    dateEnum: ['daily'],
    info: 'dbi_metric_ampere_new_dau',
    infoDetail: 'dbi_metric_ampere_new_dau',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_avg_monthly_playtime',
    value: 'ampere_avg_monthly_playtime',
    width: 300,
    width_cn: 240,
    noWrapWidth: 300,
    noWrapWidthCN: 240,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['ampere', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_avg_monthly_playtime',
    infoDetail: 'dbi_metric_ampere_avg_monthly_playtime',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_acquisition_rate',
    value: 'ampere_acquisition_rate',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['ampere', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_acquisition_rate',
    infoDetail: 'dbi_metric_ampere_acquisition_rate',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_stickiness',
    value: 'ampere_stickiness',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['ampere', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_stickiness',
    infoDetail: 'dbi_metric_ampere_stickiness',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_lifetime_player',
    value: 'ampere_lifetime_users',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['hot', 'ampere', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_metric_ampere_lifetime_users',
    infoDetail: 'dbi_metric_ampere_lifetime_users',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    text: 'dbi_metric_avg_dailly_playtime_hour',
    value: 'ampere_avg_dailly_playtime',
    width: 280,
    width_cn: 240,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'engagement',
    selectShortType: ['ampere', 'engagement'],
    dateEnum: ['daily'],
    info: 'dbi_metric_ampere_avg_dailly_playtime',
    infoDetail: 'dbi_metric_ampere_avg_dailly_playtime',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: true,
  },
  {
    // text: 'D1',
    text: 'dbi_metric_ampere_d1',
    value: 'ampere_d1',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['hot', 'ampere', 'retention'],
    // dateEnum: ['daily'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_info_ampere_d1',
    infoDetail: 'dbi_metric_info_ampere_d1',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    // text: 'D7',
    text: 'dbi_metric_ampere_d7',
    value: 'ampere_d7',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['hot', 'ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_info_ampere_d7',
    infoDetail: 'dbi_metric_info_ampere_d7',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    // text: 'D14',
    text: 'dbi_metric_ampere_d14',
    value: 'ampere_d14',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_info_ampere_d14',
    infoDetail: 'dbi_metric_info_ampere_d14',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    // text: 'D28',
    text: 'dbi_metric_ampere_d28',
    value: 'ampere_d28',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_info_ampere_d28',
    infoDetail: 'dbi_metric_info_ampere_d28',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    // text: 'D60',
    text: 'dbi_metric_ampere_d60',
    value: 'ampere_d60',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_info_ampere_d60',
    infoDetail: 'dbi_metric_info_ampere_d60',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_rolling_d1',
    value: 'ampere_rolling_d1',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_ampere_rolling_d1',
    infoDetail: 'dbi_metric_ampere_rolling_d1',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_rolling_d7',
    value: 'ampere_rolling_d7',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_ampere_rolling_d7',
    infoDetail: 'dbi_metric_ampere_rolling_d7',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_rolling_d14',
    value: 'ampere_rolling_d14',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_ampere_rolling_d14',
    infoDetail: 'dbi_metric_ampere_rolling_d14',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_rolling_d28',
    value: 'ampere_rolling_d28',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_ampere_rolling_d28',
    infoDetail: 'dbi_metric_ampere_rolling_d28',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
  {
    text: 'dbi_metric_rolling_d60',
    value: 'ampere_rolling_d60',
    width: 240,
    width_cn: 215,
    dataSource: 'ampere',
    metricValue: 'ampere',
    metricsType: 'retention',
    selectShortType: ['ampere', 'retention'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_metric_ampere_rolling_d60',
    infoDetail: 'dbi_metric_ampere_rolling_d60',
    renderType: RenderType.GROWTH_ONLY,
    isNoMore: true,
    newMore: true,
    hasByDevice: true,
    hasByDeviceBar: false,
    noStackedLineChart: true,
  },
];

const alineaConsoleMetricBase = {
  icon: 'alinea' as const,
  dataSource: 'alinea',
  metricValue: 'alinea',
};

/** KPI Trends / Stats：Alinea Analytics 分组内 PS / Xbox 指标，顺序与榜单 Console Data 一致 */
const alineaConsoleKpiMetricsOptions: IMetricsOptionItem[] = [
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_revenue',
    value: 'alinea__ps_est_revenue',
    width: 200,
    width_cn: 160,
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_revenue',
    infoDetail: 'dbi_info_alinea_ps_revenue',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_revenue_total',
    value: 'alinea__ps_est_cumulative_revenue',
    width: 220,
    width_cn: 180,
    metricsType: 'revenue',
    selectShortType: ['revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_revenue_total',
    infoDetail: 'dbi_info_alinea_ps_revenue_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_units',
    value: 'alinea__ps_est_units',
    width: 180,
    width_cn: 140,
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_units',
    infoDetail: 'dbi_info_alinea_ps_units',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_units_total',
    value: 'alinea__ps_est_cumulative_units',
    width: 200,
    width_cn: 160,
    metricsType: 'units',
    selectShortType: ['units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_units_total',
    infoDetail: 'dbi_info_alinea_ps_units_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_lifetime_players',
    value: 'alinea__ps_players',
    width: 220,
    width_cn: 200,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_lifetime_players',
    infoDetail: 'dbi_info_alinea_ps_lifetime_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_plus_total_players',
    value: 'alinea__ps_players_total',
    width: 240,
    width_cn: 220,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_plus_total_players',
    infoDetail: 'dbi_info_alinea_ps_plus_total_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_game_pass_players',
    value: 'alinea__ps_game_pass_players',
    width: 280,
    width_cn: 260,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_game_pass_players',
    infoDetail: 'dbi_info_alinea_ps_game_pass_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_game_pass_players_total',
    value: 'alinea__ps_game_pass_players_total',
    width: 300,
    width_cn: 280,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_game_pass_players_total',
    infoDetail: 'dbi_info_alinea_ps_game_pass_players_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_dau',
    value: 'alinea__ps_dau',
    width: 200,
    width_cn: 180,
    metricsType: 'engagement',
    selectShortType: ['dau', 'steamdata', 'engagement'],
    dateEnum: ['daily'],
    info: 'dbi_info_alinea_ps_dau',
    infoDetail: 'dbi_info_alinea_ps_dau',
    messagekey: 'dbi_info_alinea_dau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_mau',
    value: 'alinea__ps_mau',
    width: 200,
    width_cn: 180,
    metricsType: 'engagement',
    selectShortType: ['mau', 'steamdata', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_info_alinea_ps_mau',
    infoDetail: 'dbi_info_alinea_ps_mau',
    messagekey: 'dbi_info_alinea_mau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaPsMetricBoxBase,
    text: 'dbi_metric_alinea_ps_price',
    value: 'alinea__ps_price',
    width: 180,
    width_cn: 140,
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_ps_price',
    infoDetail: 'dbi_info_alinea_ps_price',
    renderType: RenderType.STEAM_PRICE,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_revenue',
    value: 'alinea__xbox_est_revenue',
    width: 200,
    width_cn: 160,
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_revenue',
    infoDetail: 'dbi_info_alinea_xbox_revenue',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_revenue_total',
    value: 'alinea__xbox_est_cumulative_revenue',
    width: 220,
    width_cn: 180,
    metricsType: 'revenue',
    selectShortType: ['revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_revenue_total',
    infoDetail: 'dbi_info_alinea_xbox_revenue_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_units',
    value: 'alinea__xbox_est_units',
    width: 180,
    width_cn: 140,
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_units',
    infoDetail: 'dbi_info_alinea_xbox_units',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_units_total',
    value: 'alinea__xbox_est_cumulative_units',
    width: 200,
    width_cn: 160,
    metricsType: 'units',
    selectShortType: ['units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_units_total',
    infoDetail: 'dbi_info_alinea_xbox_units_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_players',
    value: 'alinea__xbox_players',
    width: 200,
    width_cn: 160,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_players',
    infoDetail: 'dbi_info_alinea_xbox_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_game_pass_total_players',
    value: 'alinea__xbox_players_total',
    width: 280,
    width_cn: 260,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_game_pass_total_players',
    infoDetail: 'dbi_info_alinea_xbox_game_pass_total_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_game_pass_players',
    value: 'alinea__xbox_game_pass_players',
    width: 280,
    width_cn: 260,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_game_pass_players',
    infoDetail: 'dbi_info_alinea_xbox_game_pass_players',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_game_pass_players_total',
    value: 'alinea__xbox_game_pass_players_total',
    width: 300,
    width_cn: 280,
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_game_pass_players_total',
    infoDetail: 'dbi_info_alinea_xbox_game_pass_players_total',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_dau',
    value: 'alinea__xbox_dau',
    width: 200,
    width_cn: 180,
    metricsType: 'engagement',
    selectShortType: ['dau', 'steamdata', 'engagement'],
    dateEnum: ['daily'],
    info: 'dbi_info_alinea_xbox_dau',
    infoDetail: 'dbi_info_alinea_xbox_dau',
    messagekey: 'dbi_info_alinea_dau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_mau',
    value: 'alinea__xbox_mau',
    width: 200,
    width_cn: 180,
    metricsType: 'engagement',
    selectShortType: ['mau', 'steamdata', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_info_alinea_xbox_mau',
    infoDetail: 'dbi_info_alinea_xbox_mau',
    messagekey: 'dbi_info_alinea_mau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaConsoleMetricBase,
    ...alineaXboxMetricBoxBase,
    text: 'dbi_metric_alinea_xbox_price',
    value: 'alinea__xbox_price',
    width: 180,
    width_cn: 140,
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_xbox_price',
    infoDetail: 'dbi_info_alinea_xbox_price',
    renderType: RenderType.STEAM_PRICE,
  },
];

// Famitsu entries remain in the source list for rollback, but are excluded from all page selectors.
export const allMetricsOptions: IMetricsOptionItem[] = [
  {
    text: 'dbi_metric_total_revenue',
    value: 'databrain__total_revenue',
    width: 240,
    width_cn: 240,
    icon: 'databrainbluebg',
    dataSource: 'databrain',
    metricValue: 'databrain',
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'databrain'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_databrain_total_revenue_trends_kpi',
    infoDetail: 'dbi_info_databrain_total_revenue_trends_kpi',
  },
  {
    text: 'dbi_metric_lifetime_total_revenue',
    value: 'databrain__lifetime_total_revenue',
    width: 300,
    width_cn: 300,
    icon: 'databrainbluebg',
    dataSource: 'databrain',
    metricValue: 'databrain',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'databrain'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_databrain_lifetime_total_revenue_kpi',
    infoDetail: 'dbi_info_databrain_lifetime_total_revenue_kpi',
  },
  {
    text: 'dbi_metric_base_game_sales_units',
    value: 'databrain__base_game_sales_units',
    width: 260,
    width_cn: 240,
    icon: 'databrainbluebg',
    dataSource: 'databrain',
    metricValue: 'databrain',
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'databrain'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_databrain_total_units_basegame_kpi',
    infoDetail: 'dbi_info_databrain_total_units_basegame_kpi',
  },
  {
    text: 'dbi_metric_lifetime_base_game_sales_units',
    value: 'databrain__lifetime_base_game_sales_units',
    width: 320,
    width_cn: 300,
    icon: 'databrainbluebg',
    dataSource: 'databrain',
    metricValue: 'databrain',
    metricsType: 'units',
    selectShortType: ['units', 'databrain'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_databrain_lifetime_total_units_kpi',
    infoDetail: 'dbi_info_databrain_lifetime_total_units_kpi',
  },
  {
    text: 'dbi_metric_digitalRevenue_trends', // Mscience US Digital Revenue($)
    value: 'digitalRevenue',
    // width: 230,
    width: 295,
    width_cn: 260,
    noWrapWidth: 310,
    noWrapWidthCN: 281,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'mscience'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'digital_revenue',
    info: 'dbi_info_sum_selected',
    iconInfo: 'dbi_info_digital_revenue_tip_new',
    infoDetail: 'dbi_info_sum_selected',
    weekly: 'Sum MScience Digital Revenue',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_mscience_lifetime_digital_revenue_trends',
    value: 'mscienceLifetimeDigitalRevenue',
    width: 350,
    width_cn: 320,
    noWrapWidth: 350,
    noWrapWidthCN: 320,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'mscience'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_mscience_lifetime_total_revenue',
    infoDetail: 'dbi_info_mscience_lifetime_total_revenue',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_gsd_digital_units_trends', // Mscience Digital Units
    value: 'units',
    // width: 180,
    width: 245,
    width_cn: 220,
    noWrapWidth: 267,
    noWrapWidthCN: 247,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'mscience'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'digital_revenue',
    info: 'dbi_info_units_indicates_basegame',
    iconInfo: 'dbi_info_units_sold',
    infoDetail: 'dbi_info_units_indicates_basegame',
    infoSuffix: '',
    weekly: 'Sum MScience Digital Units',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_mscience_lifetime_digital_units_trends',
    value: 'mscienceLifetimeDigitalUnits',
    width: 350,
    width_cn: 320,
    noWrapWidth: 350,
    noWrapWidthCN: 320,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'units',
    selectShortType: ['units', 'mscience'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_mscience_lifetime_units_new',
    infoDetail: 'dbi_info_mscience_lifetime_units_new',
    hasByDevice: true,
  },
  {
    text: `dbi_metric_digitalARPPU_trends`, // Mscience US Digital ARPPU($)
    value: 'digitalARPPU',
    width: 330,
    width_cn: 329,
    noWrapWidth: 299,
    noWrapWidthCN: 296,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'arpu',
    selectShortType: ['mscience'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_info_arppu_usonly',
    infoDetail: 'dbi_info_arppu_usonly',
    infoSuffix: '',
  },
  {
    text: `dbi_metric_ast_us`, // Mscience US Digital AST($)
    value: 'ast',
    width: 285,
    width_cn: 280,
    noWrapWidth: 279,
    noWrapWidthCN: 274,
    dataSource: 'mscience',
    metricValue: 'mscience',
    metricsType: 'arpu',
    selectShortType: ['mscience'],
    dateEnum: ['daily', 'monthly'],
    info: 'dbi_info_ast_average',
    infoDetail: 'dbi_info_ast_average',
    infoSuffix: '',
  },
  {
    text: 'dbi_metric_physical_revenue_trends', // NPD US Physical Revenue($)
    value: 'revenue',
    valueOther: 'physicalRevenue',
    width: 305,
    width_cn: 265,
    noWrapWidth: 287,
    noWrapWidthCN: 248,
    dataSource: 'npd',
    metricValue: 'npd',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'npd'],
    dateEnum: ['monthly'],
    tabName: 'physical_revenue',
    info: 'dbi_info_sum_selected',
    infoDetail: 'dbi_info_sum_selected',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_gsd_physical_units_trends', // NPD US Physical Units
    value: 'physical_units',
    width: 263,
    width_cn: 220,
    noWrapWidth: 244,
    noWrapWidthCN: 214,
    dataSource: 'npd',
    metricValue: 'npd',
    metricsType: 'units',
    selectShortType: ['units'],
    dateEnum: ['monthly'],
    info: 'dbi_info_sum_selected',
    infoDetail: 'dbi_info_sum_selected',
    infoSuffix: '',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_gsd_digital_revenue_euro_trends', // GSD Digital Revenue(€)
    value: 'gsd_digitalRevenue',
    width: 240,
    width_cn: 230,
    dataSource: 'gsd',
    metricValue: 'gsd',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'gsd'],
    dateEnum: ['weekly'],
    tabName: 'gsd_digitalRevenue',
    info: 'dbi_info_gsd_digitalRevenue',
    infoDetail: 'dbi_info_gsd_digitalRevenue',
    infoSuffix: 'dbi_info_gsd_disabled',
  },
  {
    text: 'dbi_metric_gsd_physical_revenue_euro_trends', // GSD Physical Revenue(€)
    value: 'gsd_physicalRevenue',
    width: 250,
    width_cn: 230,
    dataSource: 'gsd',
    metricValue: 'gsd',
    metricsType: 'revenue',
    dateEnum: ['weekly'],
    selectShortType: ['revenue', 'gsd'],
    tabName: 'gsd_digitalRevenue',
    info: 'dbi_info_gsd_physicalRevenue',
    infoDetail: 'dbi_info_gsd_physicalRevenue',
    infoSuffix: 'dbi_info_gsd_disabled',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_gsd_digital_units_units_trends', // GSD Digital Units
    value: 'gsd_digitalUnits',
    width: 220,
    width_cn: 180,
    dataSource: 'gsd',
    metricValue: 'gsd',
    metricsType: 'units',
    selectShortType: ['units', 'gsd'],
    dateEnum: ['weekly'],
    tabName: 'gsd_digitalRevenue',
    info: 'dbi_info_gsd_digitalUnits',
    infoDetail: 'dbi_info_gsd_digitalUnits',
    infoSuffix: 'dbi_info_gsd_disabled',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_gsd_physical_units_gsd', // GSD Physical Units
    value: 'gsd_physicalUnits',
    width: 220,
    width_cn: 180,
    dataSource: 'gsd',
    metricValue: 'gsd',
    metricsType: 'units',
    selectShortType: ['units', 'gsd'],
    dateEnum: ['weekly'],
    tabName: 'gsd_digitalRevenue',
    info: 'dbi_info_gsd_physicalUnits',
    infoDetail: 'dbi_info_gsd_physicalUnits',
    infoSuffix: 'dbi_info_gsd_disabled',
    hasByDevice: true,
  },
  {
    text: 'dbi_metric_source_steam_pcu',
    value: 'source_steam__pcu',
    width: 220,
    icon: 'source_steam',
    dataSource: 'source_steam',
    metricValue: 'source_steam',
    metricsType: 'pcu',
    selectShortType: ['pcu', 'source_steam'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_source_steam_pcu',
  },
  {
    text: 'dbi_metric_source_steam_acu',
    value: 'source_steam__acu',
    width: 220,
    icon: 'source_steam',
    dataSource: 'source_steam',
    metricValue: 'source_steam',
    metricsType: 'pcu',
    selectShortType: ['pcu', 'source_steam'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_source_steam_acu',
  },
  {
    text: 'dbi_top_kpiOverview_steam_hourly_ccu',
    value: 'source_steam__hourly_ccu',
    width: 240,
    width_cn: 220,
    icon: 'source_steam',
    dataSource: 'source_steam',
    metricValue: 'source_steam',
    metricsType: 'pcu',
    selectShortType: ['pcu', 'source_steam'],
    dateEnum: ['hourly'],
    info: 'dbi_top_kpiOverview_steam_hourly_ccu_info',
  },
  {
    text: 'dbi_metric_vgi_steam_followers',
    value: 'steamfollowers',
    width: 320,
    width_cn: 320,
    icon: 'steam',
    dataSource: 'source_steam',
    metricValue: 'steamcharts',
    // 保留旧分类和快捷筛选契约；PC/Console 新展示分类由 resolver 单独转换。
    metricsType: 'steamFollowers',
    selectShortType: ['pcu', 'source_steam'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_steamfollowers',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_est_revenue',
    value: 'alinea__est_revenue',
    width: 360,
    width_cn: 360,
    noWrapWidth: 322,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_est_revenue',
    infoDetail: 'dbi_info_alinea_est_revenue',
    // infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Sum Premium Revenue',
    monthly: 'Sum Premium Revenue',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_jptb_cumulative_revenue_trends',
    value: 'alinea__est_cumulative_revenue',
    width: 380,
    width_cn: 380,
    noWrapWidth: 298,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: `dbi_info_alinea_est_cumulative_revenue`,
    trueDataMetric: 'alinea_calibration__revenue',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_est_units',
    value: 'alinea__est_units',
    width: 300,
    width_cn: 300,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_est_units',
    infoDetail: 'dbi_info_alinea_est_units',
    // infoSuffix: 'dbi_info_vig_disabled',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: `dbi_metric_alinea_steam_cumulative_units`,
    value: 'alinea__est_cumulative_units',
    width: 360,
    width_cn: 360,
    noWrapWidth: 245,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'units',
    selectShortType: ['units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    trueDataMetric: 'alinea_calibration__copies_sold',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_pcu',
    value: 'alinea__pcu',
    icon: 'alinea',
    width: 220,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'pcu',
    selectShortType: ['hot', 'pcu', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_alinea_pcu',
    infoDetail: 'dbi_info_alinea_pcu',
    infoSuffix: '',
    weekly: 'Peak Steam PCU',
    monthly: 'Peak Steam PCU',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_acu',
    value: 'alinea__acu',
    icon: 'alinea',
    width: 220,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'pcu',
    selectShortType: ['pcu', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_alinea_acu',
    infoDetail: 'dbi_info_alinea_acu',
    infoSuffix: '',
    weekly: 'Avg Steam ACU',
    monthly: 'Avg Steam ACU',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_mau',
    value: 'alinea__mau',
    width: 220,
    width_cn: 220,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['monthly'],
    info: 'dbi_info_alinea__mau',
    infoDetail: 'dbi_info_alinea__mau',
    messagekey: 'dbi_info_alinea_mau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_dau',
    value: 'alinea__dau',
    width: 220,
    width_cn: 220,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    selectShortType: ['steamdata', 'engagement'],
    dateEnum: ['daily'],
    info: 'dbi_info_alinea__dau',
    infoDetail: 'dbi_info_alinea__dau',
    messagekey: 'dbi_info_alinea_dau_metric_disabled_tips',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    ...alineaSteamMetricBoxBase,
    text: `dbi_metric_alinea_playtime_steam`,
    value: 'alinea__playtime',
    width: 380,
    width_cn: 380,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'playtime',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__playtime',
    infoDetail: 'dbi_info_alinea__playtime',
    weekly: 'Sum Steam Avg.Playtime(hours)',
    monthly: 'Sum Steam Avg.Playtime(hours)',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_players',
    value: 'alinea__players',
    width: 300,
    width_cn: 260,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__players',
    infoDetail: 'dbi_info_alinea__players',
    weekly: 'Sum Steam Players',
    monthly: 'Sum Steam Players',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_total_players',
    value: 'alinea__players_total',
    width: 360,
    width_cn: 300,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__players_total',
    infoDetail: 'dbi_info_alinea__players_total',
    trueDataMetric: 'alinea_calibration__register_players',
    weekly: 'Steam Total Players',
    monthly: 'Steam Total Players',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_followers',
    value: 'alinea__steamfollowers',
    width: 220,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata', 'steamFollowers'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__steamfollowers',
    infoDetail: 'dbi_info_alinea__steamfollowers',
    weekly: 'Sum Steam Followers',
    monthly: 'Sum Steam Followers',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_daily_wishlist',
    value: 'alinea__wishlists',
    width: 340,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    width_cn: 340,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_alinea__daily_wishlist',
    infoDetail: 'dbi_info_alinea__daily_wishlist',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_lifetime_wishlist',
    value: 'alinea__wishlists_total',
    width: 360,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'engagement',
    width_cn: 360,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_alinea__lifetime_wishlist',
    infoDetail: `dbi_info_alinea__lifetime_wishlist`,
    trueDataMetric: 'alinea_calibration__wishlist',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_est_price',
    value: 'alinea__est_price',
    width: 300,
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'price',
    width_cn: 300,
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea_est_price',
    infoDetail: 'dbi_info_alinea_est_price',
    // infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Avg Steam Price($)',
    monthly: 'Avg Steam Price($)',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: `dbi_metric_alinea_lifetime_weighted_price_trends`,
    value: 'alinea__lifetime_weighted_price',
    width: 400,
    width_cn: 400,
    segType: 'price',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_reviews',
    value: 'alinea__steamreviews',
    width: 220,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__steamreviews',
    infoDetail: 'dbi_info_alinea__steamreviews',
    weekly: 'Sum Steam Reviews',
    monthly: 'Sum Steam Reviews',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_total_reviews',
    value: 'alinea__cumulative_reviews',
    width: 360,
    width_cn: 300,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__cumulative_reviews',
    infoDetail: 'dbi_info_alinea__cumulative_reviews',
    weekly: 'Steam Total Reviews',
    monthly: 'Steam Total Reviews',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_positive_reviews',
    value: 'alinea__positive',
    width: 340,
    width_cn: 260,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__positive',
    infoDetail: 'dbi_info_alinea__positive',
    weekly: 'Steam Positive Reviews',
    monthly: 'Steam Positive Reviews',
  },
  {
    ...alineaSteamMetricBoxBase,
    text: 'dbi_metric_alinea_steam_total_positive_reviews',
    value: 'alinea__cumulative_positive',
    width: 420,
    width_cn: 320,
    icon: 'alinea',
    dataSource: 'alinea',
    metricValue: 'alinea',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_alinea__cumulative_positive',
    infoDetail: 'dbi_info_alinea__cumulative_positive',
    weekly: 'Steam Total Positive Reviews',
    monthly: 'Steam Total Positive Reviews',
  },
  ...alineaConsoleKpiMetricsOptions,
  {
    text: 'dbi_metric_gamalytic_steam_est_revenue', // Gamalytic Premium Revenue($)
    value: 'gamalytic__est_revenue',
    width: 360,
    width_cn: 360,
    noWrapWidth: 322,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_gamalytic_est_revenue',
    infoDetail: 'dbi_info_gamalytic_est_revenue',
    // infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Sum Premium Revenue',
    monthly: 'Sum Premium Revenue',
  },
  {
    text: 'dbi_metric_gamalytic_jptb_cumulative_revenue_trends', // Gamalytic Cumulative Revenue($)
    value: 'gamalytic__est_cumulative_revenue',
    width: 380,
    width_cn: 380,
    noWrapWidth: 298,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: `dbi_info_gamalytic_est_cumulative_revenue`,
  },
  {
    text: 'dbi_metric_gamalytic_est_units', // Gamalytic Units
    value: 'gamalytic__est_units',
    width: 300,
    width_cn: 300,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_est_units',
    infoDetail: 'dbi_info_est_units',
    // infoSuffix: 'dbi_info_vig_disabled',
  },
  {
    text: `dbi_metric_gamalytic_steam_cumulative_units`, // Gamalytic Cumulative Units
    value: 'gamalytic__est_cumulative_units',
    width: 360,
    width_cn: 360,
    noWrapWidth: 245,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'units',
    selectShortType: ['units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
  },
  {
    text: 'dbi_metric_gamalytic_steam_pcu', // Gamalytic Steam PCU
    value: 'gamalytic__pcu',
    icon: 'gamalytic',
    width: 220,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'pcu',
    selectShortType: ['hot', 'pcu', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_pcu',
    infoDetail: 'dbi_info_pcu',
    infoSuffix: '',
    weekly: 'Peak Steam PCU',
    monthly: 'Peak Steam PCU',
  },
  {
    text: 'dbi_metric_gamalytic_steam_acu', // Gamalytic Steam ACU
    value: 'gamalytic__acu',
    icon: 'gamalytic',
    width: 220,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'pcu',
    selectShortType: ['pcu', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_acu_avg',
    infoDetail: 'dbi_info_acu_avg',
    infoSuffix: '',
    weekly: 'Avg Steam ACU',
    monthly: 'Avg Steam ACU',
  },
  {
    text: 'dbi_metric_gamalytic_steam_followers', // Gamalytic Steam Followers
    value: 'gamalytic__steamfollowers',
    width: 300,
    width_cn: 300,
    icon: 'gamalytic',
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata', 'steamFollowers'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_gamalytic__steamfollowers',
    infoDetail: 'dbi_info_gamalytic__steamfollowers',
    weekly: 'Sum Gamalytic Steam Followers',
    monthly: 'Sum Gamalytic Steam Followers',
  },
  {
    text: 'dbi_metric_gamalytic_steam_daily_wishlist', // Gamalytic Daily Wishlist
    value: 'gamalytic__wishlists',
    width: 340,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'engagement',
    width_cn: 340,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_daily_wishlist',
    infoDetail: 'dbi_info_daily_wishlist',
  },
  {
    text: 'dbi_metric_gamalytic_steam_lifetime_wishlist', // Gamalytic Lifetime Wishlist
    value: 'gamalytic__wishlists_total',
    width: 360,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'engagement',
    width_cn: 360,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_gamalytic__lifetime_wishlist',
    infoDetail: `dbi_info_gamalytic__lifetime_wishlist`,
  },
  {
    text: 'dbi_metric_gamalytic_est_price', // Gamalytic Price($)
    value: 'gamalytic__est_price',
    width: 300,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'price',
    width_cn: 300,
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_est_price',
    infoDetail: 'dbi_info_est_price',
    // infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Avg Steam Price($)',
    monthly: 'Avg Steam Price($)',
  },
  {
    text: `dbi_metric_gamalytic_lifetime_weighted_price_trends`, // Gamalytic Lifetime weighted price($)
    value: 'gamalytic__lifetime_weighted_price',
    width: 400,
    width_cn: 400,
    segType: 'price',
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
  },
  {
    text: `dbi_metric_gamalytic_playtime_steam`, // Gamalytic Avg. Playtime(mins)
    value: 'gamalytic__playtime',
    width: 380,
    width_cn: 380,
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'playtime',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_gamalytic__playtime',
    infoDetail: 'dbi_info_gamalytic__playtime',
    weekly: 'Sum Steam Avg.Playtime(hours)',
    monthly: 'Sum Steam Avg.Playtime(hours)',
  },
  {
    text: 'dbi_metric_gamalytic_steam_reviews', // Gamalytic Steam Reviews
    value: 'gamalytic__steamreviews',
    width: 300,
    width_cn: 300,
    icon: 'gamalytic',
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_steamreviews',
    infoDetail: 'dbi_info_steamreviews',
    // infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Sum Steam Reviews',
    monthly: 'Sum Steam Reviews',
  },
  {
    text: 'dbi_metric_gamalytic_steam_total_reviews',
    value: 'gamalytic__cumulative_reviews',
    width: 360,
    width_cn: 300,
    icon: 'gamalytic',
    dataSource: 'gamalytic',
    metricValue: 'gamalytic',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_gamalytic__cumulative_reviews',
    infoDetail: 'dbi_info_gamalytic__cumulative_reviews',
    weekly: 'Steam Total Reviews',
    monthly: 'Steam Total Reviews',
  },
  {
    text: 'dbi_metric_vgi_steam_est_revenue', // VGI Steam Premium Revenue($)
    value: 'est_revenue',
    width: 320,
    width_cn: 320,
    noWrapWidth: 322,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'revenue',
    selectShortType: ['hot', 'revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_est_revenue',
    infoDetail: 'dbi_info_est_revenue',
    infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Sum Premium Revenue',
    monthly: 'Sum Premium Revenue',
  },
  {
    text: 'dbi_metric_vgi_steam_cumulative_revenue', // VGI Steam Cumulative Revenue($)
    value: 'est_cumulative_revenue',
    width: 360,
    width_cn: 360,
    noWrapWidth: 298,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'revenue',
    selectShortType: ['revenue', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: `dbi_info_est_revenue`,
  },
  {
    text: 'dbi_metric_vgi_steam_units', // VGI Steam Units
    value: 'est_units',
    width: 300,
    width_cn: 300,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'units',
    selectShortType: ['hot', 'units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_est_units',
    infoDetail: 'dbi_info_est_units',
    infoSuffix: 'dbi_info_vig_disabled',
  },
  {
    text: `dbi_metric_vgi_steam_cumulative_units`, // VGI Steam Cumulative Units
    value: 'est_cumulative_units',
    width: 300,
    width_cn: 300,
    noWrapWidth: 245,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'units',
    selectShortType: ['units', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
  },
  {
    text: 'dbi_metric_vgi_steam_pcu', // VGI Steam PCU
    value: 'pcu',
    icon: 'vginsights',
    width: 220,
    dataSource: 'vginsights',
    metricValue: 'steamcharts',
    metricsType: 'pcu',
    selectShortType: ['hot', 'pcu'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_pcu',
    infoDetail: 'dbi_info_pcu',
    infoSuffix: '',
    weekly: 'Peak Steam PCU',
    monthly: 'Peak Steam PCU',
  },
  {
    text: 'dbi_metric_vgi_steam_acu', // VGI Steam ACU
    value: 'acu',
    icon: 'vginsights',
    width: 220,
    dataSource: 'vginsights',
    metricValue: 'steamcharts',
    metricsType: 'pcu',
    selectShortType: ['pcu'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    tabName: 'pcu',
    info: 'dbi_info_acu_avg',
    infoDetail: 'dbi_info_acu_avg',
    infoSuffix: '',
    weekly: 'Avg Steam ACU',
    monthly: 'Avg Steam ACU',
  },
  // {
  //   text: 'dbi_metric_vgi_steam_followers', // VGI Steam Followers
  //   value: 'vginsights__steamfollowers',
  //   width: 300,
  //   width_cn: 300,
  //   icon: 'vginsights',
  //   dataSource: 'vginsights',
  //   metricValue: 'vginsights',
  //   metricsType: 'steamFollowers',
  //   selectShortType: ['steamdata', 'steamFollowers'],
  //   dateEnum: ['daily', 'weekly', 'monthly'],
  //   info: 'dbi_info_steamfollowers',
  //   infoDetail: 'dbi_info_steamfollowers',
  //   weekly: 'Sum Steam Followers',
  //   monthly: 'Sum Steam Followers',
  // },
  {
    text: 'dbi_metric_vgi_steam_daily_wishlist', // VGI Steam Daily Wishlist
    value: 'wishlists',
    width: 300,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'engagement',
    width_cn: 300,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_daily_wishlist',
    infoDetail: 'dbi_info_daily_wishlist',
  },
  {
    text: 'dbi_metric_vgi_steam_lifetime_wishlist', // VGI Steam Lifetime Wishlist
    value: 'wishlists_total',
    width: 300,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'engagement',
    width_cn: 300,
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    newMore: true,
    info: 'dbi_info_lifetime_wishlist',
    infoDetail: `dbi_info_lifetime_wishlist`,
  },
  {
    text: 'dbi_metric_vgi_steam_price', // VGI Steam Price($)
    value: 'est_price',
    width: 300,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'price',
    width_cn: 300,
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_est_price',
    infoDetail: 'dbi_info_est_price',
    infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Avg Steam Price($)',
    monthly: 'Avg Steam Price($)',
  },
  {
    text: 'dbi_metric_vgi_weighted_price', // VGI Steam Weighted Price($)
    value: 'weighted_price',
    width: 320,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_weighted_price',
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  },
  {
    text: `dbi_metric_vgi_lifetime_weighted_price`, // VGI Lifetime weighted price($)
    value: 'lifetime_weighted_price',
    width: 380,
    width_cn: 380,
    segType: 'price',
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'price',
    selectShortType: ['price', 'steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
  },
  {
    text: `dbi_metric_vgi_steam_playtime`, // VGI Steam Avg. Playtime(mins)
    value: 'playtime',
    width: 380,
    width_cn: 380,
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'playtime',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    weekly: 'Sum Steam Avg.Playtime(mins)',
    monthly: 'Sum Steam Avg.Playtime(mins)',
  },
  {
    text: 'dbi_metric_vgi_steam_reviews', // VGI Steam Reviews
    value: 'steamreviews',
    width: 210,
    width_cn: 215,
    icon: 'vginsights',
    dataSource: 'vginsights',
    metricValue: 'vginsights',
    metricsType: 'steamFollowers',
    selectShortType: ['steamdata'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_steamreviews',
    infoDetail: 'dbi_info_steamreviews',
    infoSuffix: 'dbi_info_vig_disabled',
    weekly: 'Sum Steam Reviews',
    monthly: 'Sum Steam Reviews',
  },

  ...ampereMetricOptions,

  {
    text: 'dbi_mentions',
    value: 'Mentions',
    width: 240,
    width_cn: 215,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_mentions_info',
    infoDetail: 'dbi_info_mentions_info',
  },
  {
    text: 'Brand Health',
    value: 'Brand Health',
    width: 240,
    width_cn: 215,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'dbi_info_brand_health_info',
    infoDetail: 'dbi_info_brand_health_info',
  },
  {
    text: 'Steam All Reviews',
    value: 'Steam All reviews',
    width: 240,
    width_cn: 215,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'Steam All Reviews',
    infoDetail: 'Steam All Reviews',
  },
  {
    text: 'Steam All Reviews Positive%',
    value: 'Steam All reviews Positive%',
    width: 300,
    width_cn: 300,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'Steam All Reviews Positive%',
    infoDetail: 'Steam All Reviews Positive%',
  },
  {
    text: 'Steam Added Reviews',
    value: 'Steam Added Reviews',
    width: 240,
    width_cn: 215,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'Steam Added Reviews',
    infoDetail: 'Steam Added Reviews',
  },
  {
    text: 'Steam Added Positive%',
    value: 'Steam Added Positive%',
    width: 240,
    width_cn: 215,
    dataSource: 'opinions',
    metricValue: 'opinions',
    metricsType: 'opinions',
    selectShortType: ['opinions'],
    dateEnum: ['daily', 'weekly', 'monthly'],
    info: 'Steam Added Positive%',
    infoDetail: 'Steam Added Positive%',
  },

  // newzoo

  {
    text: 'dbi_metric_mau', // MAU
    value: 'mau',
    width: 190,
    width_cn: 180,
    dataSource: 'newzoo',
    metricValue: 'newzoo',
    metricsType: 'mau',
    // selectShortType: ['mau'],
    dateEnum: ['monthly'],
    info: 'dbi_info_mau_represents',
    infoDetail: 'dbi_info_mau_represents',
    infoSuffix: '',
  },
  {
    text: 'D1', // D1
    value: 'retention_d1',
    width: 110,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    // selectShortType: ['hot'],
    // selectShortDateType:'day'
    info: 'dbi_info_retention_d1',
    infoDetail: 'dbi_info_retention_d1',
    infoSuffix: '',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'D2', // D2
    value: 'retention_d2',
    width: 110,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    info: 'dbi_info_retention_d2',
    infoDetail: 'dbi_info_retention_d2',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'D4', // D4
    value: 'retention_d4',
    width: 110,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    info: 'dbi_info_retention_d4',
    infoDetail: 'dbi_info_retention_d4',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'D7', // D7
    value: 'retention_d7',
    width: 110,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    info: 'dbi_info_retention_d7',
    infoDetail: 'dbi_info_retention_d7',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'D14', // D14
    value: 'retention_d14',
    width: 125,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    info: 'dbi_info_retention_d14',
    infoDetail: 'dbi_info_retention_d14',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'D28', // D28
    value: 'retention_d28',
    width: 125,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'retention',
    dateEnum: ['monthly'],
    info: 'dbi_info_retention_d28',
    infoDetail: 'dbi_info_retention_d28',
    renderType: RenderType.GROWTH_ONLY,
  },
  // {
  //   text: 'dbi_metric_vgi_steam_followers', // Steam Followers
  //   value: 'steamfollowers',
  //   width: 210,
  //   width_cn: 210,
  //   icon: 'steam',
  //   dataSource: 'vginsights',
  //   bubbleDataSource: 'steam', // 气泡提示显示为 Steam 数据源
  //   metricValue: 'vginsights',
  //   metricsType: 'steamFollowers',
  //   selectShortType: ['steamdata'],
  //   dateEnum: ['daily', 'weekly', 'monthly'],
  //   info: 'dbi_info_steamfollowers',
  //   infoDetail: 'dbi_info_steamfollowers',
  //   infoSuffix: 'dbi_info_vig_disabled',
  //   weekly: 'Sum Steam Followers',
  //   monthly: 'Sum Steam Followers',
  // },
  {
    text: 'dbi_metric_avg_daily_playtime', // Avg Daily Playtime (mins)
    value: 'avg_daily_playtime',
    width: 270,
    width_cn: 245,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_daily_playtime',
    infoDetail: 'dbi_info_avg_daily_playtime',
  },
  {
    text: 'dbi_metric_player_share', // Player Share
    value: 'player_share',
    width: 180,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_player_share',
    infoDetail: 'dbi_info_player_share',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_mau_growth', // MAU Growth
    value: 'mau_growth',
    dataSource: 'newzoo',
    width: 190,
    width_cn: 150,
    metricValue: 'newzoo',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_mau_growth',
    infoDetail: 'dbi_info_mau_growth',
  },
  {
    text: 'dbi_metric_mau_new', // MAU - New
    value: 'mau_new',
    width: 180,
    width_cn: 150,
    dataSource: 'newzoo',
    metricValue: 'newzoo',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_mau_new',
    infoDetail: 'dbi_info_mau_new',
  },
  {
    text: 'dbi_metric_mau_returning', // MAU - Returning
    value: 'mau_returning',
    width: 220,
    width_cn: 145,
    dataSource: 'newzoo',
    metricValue: 'newzoo',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_mau_returning',
    infoDetail: 'dbi_info_mau_returning',
  },
  {
    text: 'dbi_metric_lifetime_player', // Lifetime Players
    value: 'lifetime_player',
    width: 210,
    width_cn: 180,
    dataSource: 'newzoo',
    metricValue: 'newzoo',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_lifetime_player',
    infoDetail: 'dbi_info_lifetime_player',
  },
  {
    text: 'dbi_metric_avg_daily_sessions', // Avg Daily Sessions
    value: 'avg_daily_sessions',
    width: 230,
    width_cn: 195,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_daily_sessions',
    infoDetail: 'dbi_info_avg_daily_sessions',
  },
  {
    text: 'dbi_metric_avg_days_played', // Avg Days Played
    value: 'avg_days_played',
    width: 210,
    width_cn: 175,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_days_played',
    infoDetail: 'dbi_info_avg_days_played',
  },
  {
    text: 'dbi_metric_avg_monthly_playtime', // Avg Monthly Playtime (hours)
    value: 'avg_monthly_playtime',
    width: 300,
    width_cn: 245,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_monthly_playtime',
    infoDetail: 'dbi_info_avg_monthly_playtime',
  },
  {
    text: 'dbi_metric_avg_monthly_sessions', // Avg Monthly Sessions
    value: 'avg_monthly_sessions',
    width: 252,
    width_cn: 195,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_monthly_sessions',
    infoDetail: 'dbi_info_avg_monthly_sessions',
  },
  {
    text: 'dbi_metric_avg_playtime_per_session', // Avg Playtime Per Session (mins)
    value: 'avg_playtime_per_session',
    width: 315,
    width_cn: 275,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_avg_playtime_per_session',
    infoDetail: 'dbi_info_avg_playtime_per_session',
  },
  {
    text: 'dbi_metric_stickiness', // Stickiness
    value: 'stickiness',
    width: 165,
    width_cn: 145,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_stickiness',
    infoDetail: 'dbi_info_stickiness',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_total_hours', // Total Hours
    value: 'total_hours',
    width: 175,
    width_cn: 150,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_total_hours',
    infoDetail: 'dbi_info_total_hours',
  },
  {
    text: 'dbi_metric_churn', // Churn %
    value: 'churn',
    width: 160,
    width_cn: 130,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_churn',
    infoDetail: 'dbi_info_churn',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_acquisition', // Acquisition %
    value: 'acquisition',
    width: 190,
    width_cn: 150,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_acquisition',
    infoDetail: 'dbi_info_acquisition',
    renderType: RenderType.GROWTH_AND_RATIO,
  },
  {
    text: 'dbi_metric_time_spent_0H', // Time Spent 0-1 hrs
    value: 'time_spent_0H',
    width: 235,
    width_cn: 210,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_timespent_01',
    infoDetail: 'dbi_info_timespent_01',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_time_spent_1H', // Time Spent 1-5 hrs
    value: 'time_spent_1H',
    width: 235,
    width_cn: 210,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_timespent_15',
    infoDetail: 'dbi_info_timespent_15',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_time_spent_5H', // Time Spent 5-10 hrs
    value: 'time_spent_5H',
    width: 235,
    width_cn: 220,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_timespent_510',
    infoDetail: 'dbi_info_timespent_510',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_time_spent_10H', // Time Spent 10-25 hrs
    value: 'time_spent_10H',
    width: 240,
    width_cn: 225,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_timespent_1025',
    infoDetail: 'dbi_info_timespent_1025',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_time_spent_25H', // Time Spent 25-50 hrs
    value: 'time_spent_25H',
    width: 240,
    width_cn: 225,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_timespent_2550',
    infoDetail: 'dbi_info_timespent_2550',
    renderType: RenderType.GROWTH_ONLY,
  },
  {
    text: 'dbi_metric_time_spent_50H', // Time Spent > 50 hrs
    value: 'time_spent_50H',
    width: 240,
    width_cn: 215,
    dataSource: 'newzoo',
    metricValue: 'newzoo_weight',
    metricsType: 'noUpdate',
    dateEnum: ['monthly'],
    info: 'dbi_info_time_spent_50H',
    infoDetail: 'dbi_info_time_spent_50H',
    renderType: RenderType.GROWTH_ONLY,
  },
  // Famitsu is temporarily unavailable in Intelligence page selectors.
  // {
  //   text: 'dbi_top_sales_of_selected_time',
  //   value: 'famitsu_sales',
  //   width: 260,
  //   dataSource: 'famitsu',
  //   metricValue: 'famitsu',
  //   metricsType: 'units',
  //   selectShortType: ['units'],
  //   dateEnum: ['weekly'],
  //   renderType: RenderType.VALUE_AND_RATIO,
  // },
  // {
  //   text: 'dbi_top_price$',
  //   value: 'famitsu_price',
  //   width: 200,
  //   dataSource: 'famitsu',
  //   metricValue: 'famitsu',
  //   metricsType: 'price',
  //   selectShortType: ['price'],
  //   dateEnum: ['weekly'],
  //   info: 'dbi_top_console_japan_sales_price_columns_tips',
  //   renderType: RenderType.VALUE_AND_RATIO,
  // },
  // {
  //   text: 'dbi_top_revenue_of_selected_time$',
  //   value: 'famitsu_revenue',
  //   width: 300,
  //   dataSource: 'famitsu',
  //   metricValue: 'famitsu',
  //   metricsType: 'revenue',
  //   selectShortType: ['revenue'],
  //   dateEnum: ['weekly'],
  //   renderType: RenderType.VALUE_AND_RATIO,
  // },
  // {
  //   text: 'dbi_top_cumulative_sales_of_the_latest_week',
  //   value: 'famitsu_cumulative_sales',
  //   width: 330,
  //   dataSource: 'famitsu',
  //   metricValue: 'famitsu',
  //   metricsType: 'units',
  //   selectShortType: ['units'],
  //   dateEnum: ['weekly'],
  //   renderType: RenderType.VALUE_AND_RATIO,
  // },
  // {
  //   text: 'dbi_top_cumulative_revenue_of_the_latest_week$',
  //   value: 'famitsu_cumulative_revenue',
  //   width: 374,
  //   dataSource: 'famitsu',
  //   metricValue: 'famitsu',
  //   metricsType: 'revenue',
  //   selectShortType: ['revenue'],
  //   dateEnum: ['weekly'],
  //   renderType: RenderType.VALUE_AND_RATIO,
  // },
];

export const allMetricValues = allMetricsOptions.map((option) => option.value);

export const All_METRICS_TYPE = [
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_metric_units', value: 'units' },
  { text: 'dbi_metric_pcu', value: 'pcu' },
  { text: 'dbi_metric_mau', value: 'mau' },
  { text: 'dbi_metric_dau', value: 'dau' },
  { text: 'dbi_arpu', value: 'arpu' },
  { text: 'dbi_metric_jpseg_price', value: 'price' },
  { text: 'dbi_metric_playertime', value: 'playtime' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
  { text: 'dbi_metric_no_update', value: 'noUpdate' },
  { text: 'dbi_other_vendor', value: 'ampere' },
  { text: 'dbi_combine_engagement', value: 'engagement' },
  { text: 'dbi_opinions', value: 'opinions' },
];

// export const allMetricsTypes = [
//   { text: 'dbi_revenue', value: 'revenue' },
//   { text: 'dbi_metric_units', value: 'units' },
//   { text: 'dbi_metric_pcu', value: 'pcu' },
//   { text: 'dbi_metric_mau', value: 'mau' },
//   { text: 'dbi_arpu', value: 'arpu' },
//   { text: 'dbi_metric_jpseg_price', value: 'price' },
//   { text: 'dbi_metric_playertime', value: 'playtime' },
//   { text: 'dbi_retention', value: 'retention' },
//   { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
//   { text: 'dbi_metric_no_update', value: 'noUpdate' },
//   // { text: 'dbi_ampere', value: 'ampere' },
// ];

export const ALLMETRICS_SHORT_TYPES_DAILY = [
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_metric_units', value: 'units' },
  { text: 'dbi_metric_pcu', value: 'pcu' },
  { text: 'dbi_metric_dau', value: 'dau' },
  { text: 'dbi_arpu', value: 'arpu' },
  { text: 'dbi_metric_jpseg_price', value: 'price' },
  { text: 'dbi_metric_playertime', value: 'playtime' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
  // { text: 'dbi_metric_engagement', value: 'engagement' },
  { text: 'dbi_metric_engagement_active_level', value: 'engagement' },
  { text: 'dbi_metric_no_update', value: 'noUpdate' },
];

export const ALLMETRICS_SHORT_TYPES_WEEKLY = [
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_metric_units', value: 'units' },
  { text: 'dbi_metric_pcu', value: 'pcu' },
  { text: 'dbi_metric_mau', value: 'mau' },
  { text: 'dbi_arpu', value: 'arpu' },
  { text: 'dbi_metric_jpseg_price', value: 'price' },
  { text: 'dbi_metric_playertime', value: 'playtime' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
  { text: 'dbi_metric_no_update', value: 'noUpdate' },
];

export const ALLMETRICS_SHORT_TYPES_MONTHLY = [
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_metric_units', value: 'units' },
  { text: 'dbi_metric_pcu', value: 'pcu' },
  { text: 'dbi_metric_mau', value: 'mau' },
  { text: 'dbi_arpu', value: 'arpu' },
  { text: 'dbi_metric_jpseg_price', value: 'price' },
  { text: 'dbi_metric_playertime', value: 'playtime' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
  // { text: 'dbi_metric_engagement', value: 'engagement' },
  { text: 'dbi_metric_engagement_active_level', value: 'engagement' },
  { text: 'dbi_metric_no_update', value: 'noUpdate' },
];

export const ALLMETRICS_SHORT_TYPES_COMPARE = [
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_metric_units', value: 'units' },
  { text: 'dbi_metric_pcu', value: 'pcu' },
  { text: 'dbi_metric_mau', value: 'mau' },
  { text: 'dbi_metric_dau', value: 'dau' },
  { text: 'dbi_arpu', value: 'arpu' },
  { text: 'dbi_metric_jpseg_price', value: 'price' },
  { text: 'dbi_metric_playertime', value: 'playtime' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_metric_steam_followers', value: 'steamFollowers' },
  { text: 'dbi_opinions', value: 'opinions' },
  // { text: 'dbi_metric_engagement', value: 'engagement' },
  { text: 'dbi_metric_engagement_active_level', value: 'engagement' },
  { text: 'dbi_metric_no_update', value: 'noUpdate' },
];

export const allMetricsSourcesOption = [
  { text: 'DataBrain', value: 'databrain', icon: 'databrainbluebg' },
  { text: 'MScience', value: 'mscience', icon: 'mscience' },
  { text: 'GSD', value: 'gsd', icon: 'gsd' },
  // Famitsu is temporarily unavailable in Intelligence page selectors.
  // { text: 'Famitsu', value: 'famitsu', icon: 'famitsu' },
  { text: 'Steam', value: 'source_steam', icon: 'source_steam' },
  { text: 'Alinea Analytics', value: 'alinea', icon: 'alinea' },
  { text: 'dbi_other_vendor', value: 'ampere', icon: 'ampere' },
  { text: 'Gamalytic', value: 'gamalytic', icon: 'gamalytic' },
  { text: 'VGI', value: 'vginsights', icon: 'vginsights' },
  { text: 'NPD', value: 'npd', icon: 'npd' },
  { text: NewzooToDatabrain, value: 'newzoo', icon: 'newzoo' },
];

export const ALLMETRICSSOURCESSHORTOPTION = [
  { text: 'DataBrain', value: 'databrain', icon: 'databrainbluebg' },
  { text: 'MScience', value: 'mscience', icon: 'mscience' },
  { text: 'GSD', value: 'gsd', icon: 'gsd' },
  // Famitsu is temporarily unavailable in Intelligence page selectors.
  // { text: 'Famitsu', value: 'famitsu', icon: 'famitsu' },
  { text: 'Steam', value: 'source_steam', icon: 'source_steam' },
  { text: 'Alinea Analytics', value: 'alinea', icon: 'alinea' },
  { text: 'dbi_other_vendor', value: 'ampere', icon: 'ampere' },
  { text: 'Gamalytic', value: 'gamalytic', icon: 'gamalytic' },
  { text: 'VGI', value: 'vginsights', icon: 'vginsights' },
  { text: 'NPD', value: 'npd', icon: 'npd' },
  { text: NewzooToDatabrain, value: 'newzoo', icon: 'newzoo' },
  { text: 'Opinions', value: 'opinions' },
];

export const hideByDateType = {
  daily: ['gsd', 'npd', 'newzoo'],
  weekly: ['npd', 'newzoo', 'ampere'],
  monthly: ['gsd'],
} as any;

export const dateOption = [
  { text: 'dbi_day', value: 'daily' },
  { text: 'dbi_week', value: 'weekly' },
  { text: 'dbi_month', value: 'monthly' },
];
export const metricsType = [
  {
    value: 'metrics',
    label: 'dbi_top_metrictype',
  },
  {
    value: 'dataSource',
    label: 'dbi-sm-filter-datasource',
  },
];
export const selectCutType = [
  {
    value: 'hot',
    label: 'dbi_hot_metrics',
  },
  {
    value: 'revenue',
    label: 'dbi_revenue',
  },
  {
    value: 'units',
    label: 'dbi_metric_units',
  },
  {
    value: 'pcu',
    label: 'dbi_pcu',
  },
  {
    value: 'price',
    label: 'dbi_top_price',
  },
  {
    value: 'mscience',
    label: 'dbi_mscience',
  },
  {
    value: 'npd',
    label: 'NPD',
  },
  {
    value: 'steamdata',
    label: 'dbi_metric_steamdata',
  },
  {
    value: 'gamalytic',
    label: 'Gamalytic',
  },
  {
    // value: 'Other Vendor',
    value: 'ampere',
    label: 'dbi_other_vendor',
  },
  {
    value: 'opinions',
    label: 'dbi_opinions',
  },
  {
    value: 'all',
    label: 'dbi_benchmark_customized',
  },
];
export const selectCutTypeDay = [
  {
    value: 'hot',
    label: 'dbi_hot_metrics',
  },
  {
    value: 'revenue',
    label: 'dbi_revenue',
  },
  {
    value: 'units',
    label: 'dbi_metric_units',
  },
  {
    value: 'pcu',
    label: 'dbi_pcu',
  },
  {
    value: 'price',
    label: 'dbi_top_price',
  },
  {
    value: 'dau',
    label: 'dbi_metric_dau',
  },
  {
    value: 'retention',
    label: 'dbi_retention',
  },
  {
    value: 'engagement',
    label: 'dbi_combine_engagement',
  },
  {
    value: 'mscience',
    label: 'dbi_mscience',
  },
  {
    value: 'npd',
    label: 'NPD',
  },
  {
    value: 'steamdata',
    label: 'dbi_metric_steamdata',
  },
  {
    value: 'gamalytic',
    label: 'Gamalytic',
  },
  {
    // value: 'Other Vendor',
    value: 'ampere',
    label: 'dbi_other_vendor',
  },
  {
    value: 'opinions',
    label: 'dbi_opinions',
  },
  {
    value: 'all',
    label: 'dbi_benchmark_customized',
  },
];
export const selectCutTypeWeek = [
  {
    value: 'hot',
    label: 'dbi_hot_metrics',
  },
  {
    value: 'revenue',
    label: 'dbi_revenue',
  },
  {
    value: 'units',
    label: 'dbi_metric_units',
  },
  {
    value: 'pcu',
    label: 'dbi_pcu',
  },
  {
    value: 'price',
    label: 'dbi_top_price',
  },
  {
    value: 'mscience',
    label: 'dbi_mscience',
  },
  {
    value: 'gsd',
    label: 'GSD',
  },
  {
    value: 'steamdata',
    label: 'dbi_metric_steamdata',
  },
  {
    value: 'gamalytic',
    label: 'Gamalytic',
  },
  // {
  //   // value: 'Other Vendor',
  //   value: 'ampere',
  //   label: 'dbi_other_vendor',
  // },
  {
    value: 'opinions',
    label: 'dbi_opinions',
  },
  {
    value: 'all',
    label: 'dbi_benchmark_customized',
  },
];

export const selectCutTypeMonth = [
  {
    value: 'hot',
    label: 'dbi_hot_metrics',
  },
  {
    value: 'revenue',
    label: 'dbi_revenue',
  },
  {
    value: 'units',
    label: 'dbi_metric_units',
  },
  {
    value: 'pcu',
    label: 'dbi_pcu',
  },
  {
    value: 'price',
    label: 'dbi_top_price',
  },
  {
    value: 'mau',
    label: 'dbi_metric_mau',
  },
  {
    value: 'retention',
    label: 'dbi_retention',
  },
  {
    value: 'engagement',
    label: 'dbi_combine_engagement',
  },
  {
    value: 'mscience',
    label: 'dbi_mscience',
  },
  {
    value: 'npd',
    label: 'NPD',
  },
  {
    value: 'steamdata',
    label: 'dbi_metric_steamdata',
  },
  {
    value: 'gamalytic',
    label: 'Gamalytic',
  },
  {
    // value: 'Other Vendor',
    value: 'ampere',
    label: 'dbi_other_vendor',
  },
  {
    value: 'opinions',
    label: 'dbi_opinions',
  },
  {
    value: 'all',
    label: 'dbi_benchmark_customized',
  },
];
// 'Metric Set', 'M Science', 'GSD', 'NPD', 'Steam Data'
export const defaultDataSourceList = [
  { text: 'dbi_metric_customized', value: 'all' },
  { text: 'DataBrain', value: 'databrain', icon: 'databrainbluebg' },
  { text: 'MScience', value: 'mscience', icon: 'mscience' },
  { text: 'NPD', value: 'npd', icon: 'npd' },
  { text: 'GSD', value: 'gsd', icon: 'gsd' },
  { text: 'Gamalytic', value: 'gamalytic', icon: 'gamalytic' },
  { text: 'VGI', value: 'vginsights', icon: 'vginsights' },
  { text: 'dbi_other_vendor', value: 'ampere', icon: 'ampere' },
  // { text: NewzooToDatabrain, value: 'newzoo' },
];

// 'Metric Set', 'Revenue', 'Units', 'PCU', 'price'
export const defaultMetricTypeList = [
{
  text: 'dbi_metric_customized',
  value: 'all',
},
{ text: 'dbi_revenue', value: 'revenue' },
{ text: 'dbi_metric_units', value: 'units' },
{ text: 'dbi_metric_pcu', value: 'pcu' },
{ text: 'dbi_metric_jpseg_price', value: 'price' },
// { text: 'dbi_metric_engagement', value: 'engagement' },
{ text: 'dbi_metric_engagement_active', value: 'engagement' },
// { text: 'dbi_metric_mau', value: 'mau' },
];

// 初始化用的值
export const defaultMetricTypeVals = 'all';
export const defaultSourceVals = ['all'];
// 「自定义」默认勾选：mscience + 同名 alinea
export const defaultMDList = [
  'digitalRevenue',
  'units',
  'alinea__est_price',
  'alinea__est_revenue',
];
// 周粒度原默认指标（保留作为参考）
// export const defaultWList = [
//   'gsd_digitalUnits',
//   'gsd_physicalUnits',
//   'gsd_digitalRevenue',
//   'gsd_physicalRevenue',
// ];
// 周粒度重置指标与日粒度、月粒度保持一致
export const defaultWList = [
  'digitalRevenue',
  'units',
  'alinea__est_price',
  'alinea__est_revenue',
];

// compare-pcconsole默认指标
export const DEFAULTSELECTSHOWRTLIST = [
  'digitalRevenue',
  'units',
  'alinea__pcu',
  'alinea__est_price',
  'alinea__est_units',
];
// pcconsole-KPITrends默认指标
export const DEFAULTKPITRENDSSHOWRTLIST = [
  'digitalRevenue',
  'units',
  'alinea__est_revenue',
  'alinea__est_price',
];

export const defaultSourceMetrics = {
  mscience: ['digitalRevenue', 'units'],
  alinea: ['alinea__est_revenue', 'alinea__est_price'],
};

export const defaultMetricsSaveParams = {
  metrics: DEFAULTKPITRENDSSHOWRTLIST,
  source_metrics: defaultSourceMetrics,
  sources: ['all'],
  types: 'all',
  selectedMetricsValue: 'metrics',
  shotSelectValue: 'all',
} as any;

export const getDefaultMetricsOptions = (isCompare = false) => {
  const defaultList = isCompare ? DEFAULTSELECTSHOWRTLIST : DEFAULTKPITRENDSSHOWRTLIST;
  return allMetricsOptions?.filter((element: any) => defaultList?.includes(element.value));
};

export const filterMetricsOptionsByDataSources = (
  metricsOptionsList: IMetricsOptionItem[] = [],
  excludeDataSources: string[] = [],
): IMetricsOptionItem[] => {
  if (isEmpty(metricsOptionsList)) {
    return [];
  }

  if (isEmpty(excludeDataSources)) {
    return metricsOptionsList;
  }

  const excludeDataSourcesSet = new Set(excludeDataSources);

  return metricsOptionsList.filter(item => {
    return !excludeDataSourcesSet.has(item?.dataSource);
  });
};

// 通过metricValue获取options
export const getMetricOptionByValue = (
  list: any,
  // 使用 options 配置列表的顺序
  useConfigOrder = false,
  // 所有配置项
  allMetricsOptionsList = allMetricsOptions,
) => {
  try {
    // return allMetricsOptionsList?.filter((element: any) => list?.includes(element.value));
    /**
     * 筛选器内展示的 options，需要保证按照选中值的顺序，后选中的放在最前面。所以需要以选中值为基准获取对应 options 数据
     * 表格表头使用配置的顺序
     */
    return useConfigOrder
      ? allMetricsOptionsList?.filter((element: any) => list?.includes(element.value))
      : list
          ?.map((metric: string) => {
            const currentOption = allMetricsOptionsList?.find((item) => item.value === metric);
            return currentOption;
          })
          ?.filter(Boolean);
  } catch (exception) {
    return getDefaultMetricsOptions();
  }
};

// 将options转为source_metrics
export const getSourceMetricsByValue = (list: any) => {
  const metricOptions = getMetricOptionByValue(list);
  const metricTarget: any = {};
  metricOptions.forEach((element: any) => {
    const type = element?.metricValue;
    if (metricTarget[type]) {
      metricTarget[type].push(element.value);
    } else {
      metricTarget[type] = [element.value];
    }
  });
  return metricTarget;
};

const arraysEqualIgnoreOrder = (arr1: any, arr2: any) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  if (set1.size !== set2.size) {
    return false;
  }
  for (const item of set1) {
    if (!set2.has(item)) {
      return false;
    }
  }
  return true;
};

const getShourtCutKey = (key: any, typeCur = 'monthly', excludeDataSources = SEGMENT_DEFAULT_EXCLUDE_DATA_SOURCES) => {
  const filterMetricsByDateType = allMetricsOptions.filter((element: any) =>
    element.dateEnum.includes(typeCur) && !excludeDataSources.includes(element.dataSource),
  );
  const metricsLst = filterMetricsByDateType?.filter(
    (item: any) => item?.selectShortType && item?.selectShortType?.includes(key),
  );
  return metricsLst?.map((item: any) => item.value) || [];
};

// 根据ShortCutNameCur
export const getShortCutNameCur = (
  metricsValsList: any,
  typeCur: string,
  selectCutTypeCur: any[],
) => {
  let keyvalue = 'all';
  selectCutTypeCur?.forEach((item: any) => {
    if (arraysEqualIgnoreOrder(metricsValsList, getShourtCutKey(item?.value, typeCur))) {
      keyvalue = item?.value;
      return;
    }
  });
  return keyvalue;
};

// 根据时间粒度过滤source标签
export const filterSourceByDateType = (source: string[], dateType = '') => {
  const dateTypeCur = toDateTypeLy[dateType];
  const typeEmunList: string[] = hideByDateType[dateTypeCur];
  const filterSourceOptions = source?.filter((element) => !typeEmunList?.includes(element)) || [];
  if (filterSourceOptions?.length > 0) {
    return source;
  }
  return ['all'];
};
